import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets';

export interface MainFinding {
  kit_id: string;
  sample_health_id: number;
  user_value: number;
  user_string?: string;
  evaluation_color: string;
  evaluation_text?: string;
  detected_text?: string;
  priority?: number;
  action_items_count?: number;
  // Nested relations (using withGraphJoined aliases)
  gvh?: {
    id: number;
    name: string;
    category_title?: string;
    data_type: string;
    range_bar_display?: boolean;
    scale_bar_min?: number;
    scale_bar_max?: number;
    short_description?: string;
    taxa_level?: string;
    kic?: {
      id: number;
      category_title?: string;
      kis?: {
        id: number;
        display_title: string;
      };
    };
    gvhkr?: Array<{
      id: number;
      gut_vaginal_health_name?: string;
      gut_vaginal_health_id: number;
      range_lower: number;
      range_upper: number;
      evaluation_color: string;
      sci_version?: string;
    }>;
  };
}

interface MainFindingsResponse {
  mainFindings: MainFinding[];
}

export const useMainFindings = (kitId?: string) => {
  return useQuery({
    queryKey: ['mainFindings', kitId],
    queryFn: async () => {
      if (!kitId) throw new Error('Kit ID is required');
      const response: MainFindingsResponse = await API.get(
        apiName,
        `${apiBasePath}/kits/${kitId}/main-findings`,
        {},
      );
      return response;
    },
    enabled: !!kitId,
  });
};

export const useMainFindingsWithRanges = (kitId?: string) => {
  return useQuery({
    queryKey: ['mainFindingsWithRanges', kitId],
    queryFn: async () => {
      if (!kitId) throw new Error('Kit ID is required');
      const response: MainFindingsResponse = await API.get(
        apiName,
        `${apiBasePath}/kits/${kitId}/main-findings-with-ranges`,
        {},
      );
      return response;
    },
    enabled: !!kitId,
  });
};
